// src/pages/Analytics.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Container, useTheme } from '@mui/material';
import { KeyboardArrowLeft } from '@mui/icons-material';
import AdminHeader from '../components/AdminHeader';

const Analytics = () => {
    const navigate = useNavigate();
    const theme = useTheme();

    return (
        <Box sx={{
            py: 4, minHeight: '100vh',
            backgroundColor: theme.palette.background.default
        }}>
            <Container maxWidth="lg">
                <AdminHeader />

                {/* Back Button */}
                <Box sx={{ mb: 4 }}>
                    <Button
                        onClick={() => navigate('/admin')}
                        startIcon={<KeyboardArrowLeft sx={{ fontSize: '28px !important' }} />}
                        variant="outlined"
                        sx={{
                            color: '#ff7eb9', borderColor: '#ff7eb9',
                            backgroundColor: 'rgba(255,126,185,0.06)',
                            fontWeight: 'bold', fontSize: '1rem',
                            px: 3, py: 1.5, borderRadius: '12px',
                            textTransform: 'none', transition: 'all 0.3s ease',
                            '&:hover': {
                                backgroundColor: '#ff7eb9', color: 'white',
                                borderColor: '#ff4a97', transform: 'translateY(-2px)',
                                boxShadow: '0 6px 20px rgba(255,126,185,0.3)'
                            }
                        }}
                    >
                        Назад кон Admin Панел
                    </Button>
                </Box>

                {/* Content */}
                <Box sx={{
                    display: 'flex', flexDirection: 'column',
                    alignItems: 'center', justifyContent: 'center',
                    minHeight: '60vh', textAlign: 'center',
                    border: '2px dashed rgba(255,126,185,0.3)',
                    borderRadius: '24px',
                    backgroundColor: theme.palette.mode === 'dark'
                        ? 'rgba(255,126,185,0.05)'
                        : 'rgba(255,126,185,0.03)',
                    p: 6
                }}>
                    {/* Icon */}
                    <Box sx={{
                        width: 100, height: 100, borderRadius: '50%',
                        background: 'linear-gradient(135deg, #ff7eb9, #AB47BC)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: '3rem', mb: 4,
                        boxShadow: '0 8px 32px rgba(255,126,185,0.35)',
                        animation: 'pulse 2s ease-in-out infinite'
                    }}>
                        📊
                    </Box>

                    <Typography variant="h2" sx={{
                        fontWeight: 900, mb: 2,
                        background: 'linear-gradient(45deg, #ff7eb9, #AB47BC)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        fontSize: { xs: '2rem', md: '3rem' }
                    }}>
                        Аналитика
                    </Typography>

                    {/* Divider */}
                    <Box sx={{
                        width: 80, height: 4, borderRadius: 2,
                        background: 'linear-gradient(90deg, #ff7eb9, #AB47BC)',
                        mb: 3
                    }} />

                    <Typography variant="h5" sx={{
                        color: theme.palette.text.secondary,
                        mb: 2, fontWeight: 500
                    }}>
                        🚧 Оваа страница е во развој
                    </Typography>

                    <Typography variant="body1" sx={{
                        color: theme.palette.text.disabled,
                        maxWidth: 500, lineHeight: 1.8, mb: 4
                    }}>
                        Наскоро ќе биде достапна детална аналитика за корисници,
                        програми, приходи и активност на платформата.
                    </Typography>

                    {/* Coming Soon Chip */}
                    <Box sx={{
                        px: 4, py: 1.5, borderRadius: '50px',
                        background: 'linear-gradient(45deg, #ff7eb9, #AB47BC)',
                        color: 'white', fontWeight: 'bold',
                        fontSize: '1rem',
                        boxShadow: '0 4px 15px rgba(255,126,185,0.4)',
                        letterSpacing: 1
                    }}>
                        ⏳ НАСКОРО
                    </Box>
                </Box>
            </Container>

            <style>{`
                @keyframes pulse {
                    0% { transform: scale(1); box-shadow: 0 8px 32px rgba(255,126,185,0.35); }
                    50% { transform: scale(1.08); box-shadow: 0 12px 40px rgba(255,126,185,0.55); }
                    100% { transform: scale(1); box-shadow: 0 8px 32px rgba(255,126,185,0.35); }
                }
            `}</style>
        </Box>
    );
};

export default Analytics;